import { render, staticRenderFns } from "./Finalizadoras.vue?vue&type=template&id=4be98cf5"
import script from "./Finalizadoras.vue?vue&type=script&lang=js"
export * from "./Finalizadoras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports